// Mock call driver for the power dialer, on when localStorage.sgPowerDialerMock === "1".
// Twilio webhooks point at QE, so local calls can't produce real outcomes;
// this simulates them. Everything else (tasks, complete, logs) uses the real APIs.

export const isPowerDialerMock = () => {
  try {
    return localStorage.getItem("sgPowerDialerMock") === "1";
  } catch (e) {
    return false;
  }
};

// By queue position, so one 10-call session reaches every state.
const DEFAULT_SCRIPT = [
  "connected",
  "voicemail",
  "no-answer",
  "busy",
  "failed",
  "connected-high",
  "voicemail",
  "connected",
  "no-answer",
  "voicemail"
];

const script = () => {
  try {
    const custom = localStorage.getItem("sgPowerDialerMockScript");
    return custom ? custom.split(",").map(s => s.trim()).filter(Boolean) : DEFAULT_SCRIPT;
  } catch (e) {
    return DEFAULT_SCRIPT;
  }
};

const DELAY = { connected: 1500, "connected-high": 1500, voicemail: 2000, "no-answer": 3000, busy: 1000, failed: 600 };

// callSid -> same shape as GET /ds/twilio/call-state/{callSid}
const calls = {};

export const mockDriver = {
  mock: true,
  dial(item = {}, { position = 0 } = {}) {
    const callSid = `CAmock${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
    const steps = script();
    const kind = steps[position % steps.length];
    calls[callSid] = { status: "ringing", answeredBy: "unknown", dialResult: "" };
    setTimeout(() => {
      const c = calls[callSid];
      if (!c || c.status === "completed") return;
      if (kind.startsWith("connected")) {
        const high = kind === "connected-high";
        Object.assign(c, {
          status: "in-progress",
          answeredBy: "human",
          suggestion: {
            outcome: high ? "Connected" : "Interested",
            summary: high ? "Demo next Tuesday" : "Asked for pricing by email",
            confidence: high ? 0.95 : 0.6
          }
        });
      } else if (kind === "voicemail") {
        Object.assign(c, { status: "in-progress", answeredBy: "machine_end_beep" });
      } else {
        Object.assign(c, { status: "completed", dialResult: kind });
      }
    }, DELAY[kind] || 1500);
    return Promise.resolve({ callSid });
  },
  hangup(callSid) {
    const c = calls[callSid];
    if (c && c.status !== "completed") Object.assign(c, { status: "completed", dialResult: "completed" });
  },
  callState(callSid) {
    return Promise.resolve(calls[callSid] ? { ...calls[callSid] } : { status: "completed", dialResult: "failed" });
  },
  // Message "plays" for 1.5s, then the call ends.
  dropVoicemail({ callSid }) {
    setTimeout(() => mockDriver.hangup(callSid), 1500);
    return Promise.resolve({ status: "success" });
  }
};

// localStorage.sgPowerDialerMockContacts = '{"Jane Doe": {"lastCalledAt": 1759800000000, "timeZone": "Asia/Tokyo", "mobilePhone": ["+15550002"]}}'
// is merged over the loaded contacts by name, to try the skip / calling-hours / next-number settings.
export const mockContactOverrides = (rows = []) => {
  if (!isPowerDialerMock()) return rows;
  let map = {};
  try {
    map = JSON.parse(localStorage.getItem("sgPowerDialerMockContacts")) || {};
  } catch (e) {}
  rows.forEach(r => {
    const c = r?.contact;
    const over = c && map[[c.firstName, c.lastName].filter(Boolean).join(" ")];
    if (over) Object.assign(c, over);
  });
  return rows;
};
